import {HttpVerbo, xfetch} from "../util";
import {UsuarioCmd} from "../tipos/cmd/usuario-cmd";

export default class UsuarioServico {
  static getUsuario = (idUsuario: number) => {
    return xfetch(`/usuario/${idUsuario}`, {}, HttpVerbo.GET)
      .then(res => res.json())
  }

  static cadastrarUsuario = (cmd: UsuarioCmd) => {
    return xfetch(`/usuario`, cmd, HttpVerbo.POST)
      .then(res => res.json())
  }
}